import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Grid } from "@mui/material";
import SearchableSelect, {
  SelectOption,
} from "app/components/SearchableSelect";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { selectTreatment } from "store/global/fields/selector";
import { actions } from "store/global/fields/slice";
import { useStyles } from "../styles";
interface TProps {
  value: number | "All";
  bankId: number;
  changeValue: (value: number) => void;
  disabled?: boolean;
  showAll: boolean;
  fetchAll: boolean;
  showBlank?: boolean;
  xs?: number;
  isRequired?: boolean;
}
const TreatmentTypeFiled = (props: TProps) => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const List = useSelector(selectTreatment);

  const { t } = useTranslation();

  useEffect(() => {
    if (props.showBlank) {
      dispatch(
        actions.getTreatmentListByBank({
          bankId: props.bankId,
          all: props.fetchAll,
        })
      );
    } else if (props.showAll) {
      dispatch(
        actions.getTreatmentListByBank({
          bankId: props.bankId,
          all: props.fetchAll,
        })
      );
    } else if (props.bankId > 0) {
      dispatch(
        actions.getTreatmentListByBank({
          bankId: props.bankId,
          all: props.fetchAll,
        })
      );
    } else {
      dispatch(actions.getTreatmentListSuccess({ items: [] }));
    }

    return () => {};
  }, [props.bankId, props.fetchAll]);

  const options: SelectOption[] = List.items.map((item: any) => ({
    label: item.treatmentName,
    value: item.id,
    raw: item,
  }));

  const showAllOption = props.showAll
    ? { label: t("COMMON.ALL"), value: 0 }
    : props.showBlank
    ? { label: t("COMMON.PLEASE_SELECT"), value: 0 }
    : undefined;

  return (
    <Grid item xs={props.xs ? props.xs : 2}>
      <label className={styles.label}>
        {t("TIMESLOT.TREATMENT_TYPE")}
        {props.isRequired && <span style={{ color: "red" }}> *</span>}
        {Number(props.value) > 0 ? (
          <Link
            to={`/treatment-types/${props.value}/view`}
            target="_blank"
            style={{ textDecoration: "none" }}
            rel="noopener noreferrer"
          >
            <OpenInNewIcon fontSize="small" />
          </Link>
        ) : null}
      </label>
      <SearchableSelect
        options={options}
        value={(props.value as any) ?? ""}
        onChange={(val) => props.changeValue(Number(val))}
        disabled={props.disabled}
        searchable
        className={styles.textEnabled}
        showAllOption={showAllOption}
      />
    </Grid>
  );
};
export default TreatmentTypeFiled;
